import { artistHref } from '@/features/artists/artistHref'
import { ArrowUpToLine, GripVertical, Trash2 } from 'lucide-react'

import type { QueueItem } from '@/audio/store'
import { TrackRow } from '@/components/TrackRow'

export interface QueueUpNextRowProps {
  item: QueueItem
  position: number
  count: number
  dragging: boolean
  editing: boolean
  onPlay: () => void
  onRemove: () => void
  onMoveToTop: () => void
  onReorder: () => void
  onReorderFocus: () => void
}

/** Tap to play, swipe to remove, hold to move, or use the small menu. */
export function QueueUpNextRow({ item, position, count, dragging, editing, onPlay, onRemove, onMoveToTop, onReorder, onReorderFocus }: QueueUpNextRowProps) {
  return <TrackRow
    title={item.title}
    artistName={item.artistName}
    artistHref={artistHref({ local_artist_id: item.localArtistId, artist_id: item.artistId })}
    includeArtistMenu={false}
    albumName={item.albumName}
    durationMs={item.durationMs}
    coverUrl={item.coverUrl}
    onPlay={onPlay}
    onMenuCloseAutoFocus={editing ? (event) => { event.preventDefault(); onReorderFocus() } : undefined}
    className={dragging ? 'cursor-grabbing bg-surface-hover ring-2 ring-inset ring-accent shadow-lg' : editing ? 'bg-accent-soft ring-1 ring-inset ring-accent/50' : undefined}
    menuItems={[
      { label: 'Play next', icon: ArrowUpToLine, disabled: position === 0, onSelect: onMoveToTop },
      { label: 'Reorder', icon: GripVertical, disabled: count < 2, onSelect: onReorder },
      { label: 'Remove from queue', icon: Trash2, destructive: true, onSelect: onRemove },
    ]}
  />
}
